import React from 'react';

const CONTACT_EMAIL = 'salient.mkt@gmail.com';
const LAST_UPDATED = '1 de marzo de 2025';

const PrivacyPolicy = () => {
  return (
    <article className="bg-gray-50 min-h-screen">
      <header className="bg-gray-800 text-white pt-28 pb-16 md:pt-64">
        <div className="contain px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">Política de privacidad</h1>
          <p className="text-gray-300 text-lg">SALIENT Hub Multiservicios</p>
          <p className="text-gray-400 mt-1">Última actualización: {LAST_UPDATED}</p>
        </div>
      </header>

      <div className="contain px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="max-w-4xl mx-auto space-y-10 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">1. Identidad del responsable</h2>
            <p>
              SALIENT HUB (en adelante “la Empresa”), con domicilio en México, es responsable del tratamiento de los datos personales que recaba a través de sus plataformas digitales, sitios web, aplicaciones, sistemas SaaS y servicios asociados.
            </p>
            <p className="mt-3">
              La Empresa opera como un Hub multiservicios que ofrece:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-2">
              <li>Soluciones tecnológicas y automatización empresarial</li>
              <li>Servicios de marketing digital y gestión de leads</li>
              <li>Comercio electrónico de bienes y productos</li>
              <li>Intermediación en bienes inmuebles</li>
              <li>Servicios de agencia de viajes en línea</li>
              <li>Integraciones con plataformas externas como Meta (Facebook/WhatsApp), pasarelas de pago y proveedores tecnológicos</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">2. Datos personales que recabamos</h2>
            <p className="mb-4">Podemos recabar los siguientes datos:</p>
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-gray-900">a) Datos de identificación</h3>
                <ul className="list-disc list-inside ml-2 mt-1 space-y-0.5">
                  <li>Nombre completo</li>
                  <li>Razón social</li>
                  <li>RFC (cuando aplique)</li>
                  <li>Domicilio</li>
                  <li>Teléfono</li>
                  <li>Correo electrónico</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">b) Datos financieros</h3>
                <ul className="list-disc list-inside ml-2 mt-1 space-y-0.5">
                  <li>Información de pago</li>
                  <li>Datos de facturación</li>
                  <li>Información bancaria (cuando aplique)</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">c) Datos comerciales</h3>
                <ul className="list-disc list-inside ml-2 mt-1 space-y-0.5">
                  <li>Preferencias de compra</li>
                  <li>Historial de transacciones</li>
                  <li>Interacciones con chatbots y sistemas automatizados</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">d) Datos de navegación</h3>
                <ul className="list-disc list-inside ml-2 mt-1 space-y-0.5">
                  <li>Dirección IP</li>
                  <li>Cookies</li>
                  <li>Datos de comportamiento en el sitio</li>
                  <li>Información técnica del dispositivo</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">e) Datos relacionados con servicios específicos</h3>
                <p className="mt-1">Para bienes inmuebles:</p>
                <ul className="list-disc list-inside ml-2 mt-1 space-y-0.5">
                  <li>Información patrimonial proporcionada voluntariamente</li>
                  <li>Documentación legal para procesos de compra/venta</li>
                </ul>
                <p className="mt-2">Para agencia de viajes:</p>
                <ul className="list-disc list-inside ml-2 mt-1 space-y-0.5">
                  <li>Información de pasajeros</li>
                  <li>Datos para reservaciones (aerolíneas, hoteles, etc.)</li>
                  <li>Información requerida por proveedores turísticos</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">3. Finalidades del tratamiento</h2>
            <p className="mb-3">Los datos personales serán utilizados para:</p>
            <div>
              <h3 className="font-semibold text-gray-900">Finalidades primarias</h3>
              <ul className="list-disc list-inside ml-2 mt-1 space-y-0.5">
                <li>Proveer servicios contratados</li>
                <li>Procesar pagos</li>
                <li>Gestionar cuentas de usuario</li>
                <li>Administrar plataformas SaaS</li>
                <li>Enviar notificaciones operativas</li>
                <li>Gestionar procesos de compra/venta</li>
                <li>Gestionar reservaciones de viaje</li>
              </ul>
            </div>
            <div className="mt-4">
              <h3 className="font-semibold text-gray-900">Finalidades secundarias</h3>
              <ul className="list-disc list-inside ml-2 mt-1 space-y-0.5">
                <li>Envío de promociones</li>
                <li>Análisis estadístico</li>
                <li>Mejora de servicios</li>
                <li>Marketing digital</li>
              </ul>
              <p className="mt-3 italic">El titular puede oponerse a finalidades secundarias enviando solicitud por escrito.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">4. Uso de WhatsApp, chatbots y automatización</h2>
            <p className="mb-3">La Empresa puede utilizar:</p>
            <ul className="list-disc list-inside ml-2 space-y-0.5 mb-4">
              <li>API de WhatsApp Business</li>
              <li>Chatbots automatizados</li>
              <li>Sistemas de inteligencia artificial</li>
              <li>Webhooks y herramientas de automatización</li>
            </ul>
            <p className="mb-2">Las conversaciones pueden almacenarse con fines de:</p>
            <ul className="list-disc list-inside ml-2 space-y-0.5 mb-3">
              <li>Atención al cliente</li>
              <li>Seguimiento de leads</li>
              <li>Cumplimiento contractual</li>
              <li>Mejora del servicio</li>
            </ul>
            <p>La Empresa no enviará mensajes masivos sin consentimiento previo del titular.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">5. Transferencia de datos</h2>
            <p className="mb-3">Los datos podrán compartirse con:</p>
            <ul className="list-disc list-inside ml-2 space-y-0.5 mb-3">
              <li>Proveedores de pago</li>
              <li>Plataformas tecnológicas (ej. Meta Platforms, Inc.)</li>
              <li>Proveedores de hosting</li>
              <li>Socios comerciales</li>
              <li>Proveedores turísticos</li>
              <li>Instituciones financieras</li>
              <li>Autoridades competentes cuando sea requerido por ley</li>
            </ul>
            <p>La Empresa se asegurará de que dichos terceros cumplan con estándares adecuados de protección de datos.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">6. Protección y seguridad</h2>
            <p className="mb-3">La Empresa implementa medidas técnicas y administrativas razonables como:</p>
            <ul className="list-disc list-inside ml-2 space-y-0.5 mb-3">
              <li>Encriptación SSL</li>
              <li>Acceso restringido</li>
              <li>Firewalls</li>
              <li>Contenedores y servidores protegidos</li>
              <li>Control de acceso por roles</li>
            </ul>
            <p>Sin embargo, ningún sistema es 100% infalible.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">7. Derechos ARCO (México)</h2>
            <p className="mb-3">El titular puede ejercer en cualquier momento sus derechos de:</p>
            <ul className="list-disc list-inside ml-2 space-y-0.5 mb-4">
              <li>Acceso</li>
              <li>Rectificación</li>
              <li>Cancelación</li>
              <li>Oposición</li>
            </ul>
            <p className="mb-2">Mediante solicitud enviada a:</p>
            <p className="mb-4">
              <a href={`mailto:${CONTACT_EMAIL}`} className="text-salient-primary hover:underline font-medium">{CONTACT_EMAIL}</a>
            </p>
            <p className="mb-2">La solicitud deberá incluir:</p>
            <ul className="list-disc list-inside ml-2 space-y-0.5">
              <li>Nombre completo</li>
              <li>Medio para comunicar respuesta</li>
              <li>Descripción clara del derecho a ejercer</li>
              <li>Identificación oficial</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">8. Uso de cookies</h2>
            <p className="mb-3">El sitio puede utilizar cookies para:</p>
            <ul className="list-disc list-inside ml-2 space-y-0.5 mb-3">
              <li>Analítica web</li>
              <li>Seguimiento de comportamiento</li>
              <li>Personalización de experiencia</li>
              <li>Publicidad segmentada</li>
            </ul>
            <p>El usuario puede deshabilitarlas desde su navegador.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">9. Menores de edad</h2>
            <p>Los servicios no están dirigidos a menores de edad sin consentimiento de padres o tutores.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">10. Modificaciones</h2>
            <p>La Empresa se reserva el derecho de modificar esta política en cualquier momento. Las modificaciones serán publicadas en el sitio web correspondiente.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">11. Contacto</h2>
            <p className="mb-2">Para cualquier duda relacionada con esta política:</p>
            <p>
              Correo electrónico: <a href={`mailto:${CONTACT_EMAIL}`} className="text-salient-primary hover:underline font-medium">{CONTACT_EMAIL}</a>
            </p>
            <p className="mt-2">
              Sitio web: <a href="https://www.salient.mx" target="_blank" rel="noopener noreferrer" className="text-salient-primary hover:underline">https://www.salient.mx</a>
            </p>
          </section>
        </div>
      </div>
    </article>
  );
};

export default PrivacyPolicy;
